export function countsById<T extends { id: string }>(
  items: T[],
  pick: (item: T) => number | null,
): Map<string, number> {
  const counts = new Map<string, number>()
  for (const item of items) {
    const count = pick(item)
    if (count !== null) counts.set(item.id, count)
  }
  return counts
}
